<template>
    <div class="recommendations text-center">
        <h2>{{headerText}}</h2>
        <p v-if="subText">{{subText}}</p>
        <div
            class='recommendations__container'
            :class="`recommendations__container--${className}`">
            <div
                class='recommendations__container__block'
                :class="`recommendations__container--${className}__block`"
                v-for="(item, key) in productsToDisplay"
                :key="key">
                <product-card
                    :item="item"
                    :hideTitle="hideTitle"
                    :hidePrice="hidePrice"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCard from '@/components/partials/account/shop/ProductCard';

export default {
    name: 'Recommendations',
    components: {
        ProductCard,
    },
    props: {
        className: {
            required: true,
            type: String,
        },
        headerText: {
            required: true,
            type: String,
        },
        hideTitle: {
            required: false,
            type: Boolean,
        },
        hidePrice: {
            required: false,
            type: Boolean,
        },
        numItems: {
            required: true,
            type: Number,
        },
        productIds: {
            required: false,
            type: Array,
        },
        excludeIds: {
            required: false,
            type: Array,
        },
        subText: {
            required: false,
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            orderSummary: 'shop/getOrderSummary',
            recommendations: 'shop/getRecommendations',
        }),
        filteredProducts() {
            return this.recommendations.filter((item) => {
                return this.isItemInOrder(item) || this.isItemExcluded(item) || (this.productIds && !this.isItemInProductIds(item)) ? false : item;
            });
        },
        productsToDisplay() {
            return this.filteredProducts.slice(0, this.numItemsToDisplay);
        },
        numItemsToDisplay() {
            return this.numItems > 2 ? this.getNumItemsForViewPort() : this.numItems;
        },
        isMobile() {
            return this.window.width <= this.window.mobileBreakpoint;
        },
        isTablet() {
            return this.window.width <= this.window.tabletBreakpoint && this.window.width > this.window.mobileBreakpoint;
        },
    },
    created() {
        this.$store.dispatch('shop/fetchProducts');
        this.$store.dispatch('shop/fetchOrderSummary');
    },
    data() {
        return {
            window: {
                width: 0,
                mobileBreakpoint: 840,
                tabletBreakpoint: 1200,
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
        },
        getNumItemsForViewPort() {
            const numItemsForMobile = this.isMobile ? 2 : this.numItems;
            const numItemsForTablet = this.isTablet ? 3 : this.numItems;
            return numItemsForMobile < numItemsForTablet ? numItemsForMobile : numItemsForTablet;
        },
        isItemInOrder(item) {
            return this.orderSummary[0] && this.orderSummary[0].products?.find((product) => item.productId === product.id);
        },
        isItemInProductIds(item) {
            return this.productIds && this.productIds.find((id) => item.productId === id);
        },
        isItemExcluded(item) {
            return this.excludeIds && this.excludeIds.find((id) => item.productId === id);
        },
    },
};
</script>

<style scoped lang='scss'>
$mobile-breakpoint: 840px;

.recommendations {
    &__container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 224px;
        padding: 5px;
        margin-bottom: 90px;
        gap: 36px;
        &__block {
            width: 176px;
            height: 100%;
        }
        @media screen and (max-width: $mobile-breakpoint) {
            height: 187px;
            gap: 10px;
            &__block {
                width: 146px;
            }
        }
        &--bestsellers {
            height: 323px;
            gap: 16px;
            &__block {
                width: 260px;
            }
            @media screen and (max-width: $mobile-breakpoint) {
                height: 187px;
                gap: 10px;
                &__block {
                    width: 146px;
                }
            }
        }
        &--order-summary {
            height: 208px;
            &__block {
                width: 165px;
            }
            @media screen and (max-width: $mobile-breakpoint) {
                height: 265px;
                &__block {
                    width: 202px;
                }
            }
        }
        &--next-delivery {
            height: 155px;
            gap: 20px;
            &__block {
                width: 120px;
            }
        }
    }
}
</style>
